<div class="na-page">
  <main class="na-main">
    <h1 class="na-title">Access Denied</h1>
    <p class="na-message">You don't have permission to access this page.</p>
    <button type="button" class="na-back-btn" (click)="goBack()">Go Back</button>
  </main>
</div>
